/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState } from 'react'
import { UserProviderProps } from '../types/globalTypes'

interface IAuthContext {
  token: string | null
  setToken: React.Dispatch<React.SetStateAction<string | null>>
}

export const AuthContext = createContext<IAuthContext>({
  token: null,
  setToken: () => {},
})

export const AuthProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [token, setToken] = useState<string | null>(null)

  return (
    <AuthContext.Provider value={{ token, setToken }}>
      {children}
    </AuthContext.Provider>
  )
}
